/**
 * [mojdzial1006, paczka MD-KIT → właściciel MD-ZESPOL, projekt §2.2, §3.9–3.13] REJESTR — GRUPA „ZESPÓŁ”.
 *
 * Sześć miejsc w kolejności rzędu: Ludzie (importowane z `ludzie.js` — miejsce paczki MD-START), Dostępy, Sprzęt, Sejf haseł,
 * Dokumenty, Procedury. Dokumenty wchodzą na klucz `DeptDocsView` ∨ `DepartmentManagerAccess` (dzisiejsze `permission`
 * zakładki — nazwa klucza pada na ekranie WYŁĄCZNIE w `AccessDeniedScreen`). Procedury rysuje komponent paczki PROC w trybie
 * działu (aneks PROC-MD, 3.13) — do jego dostarczenia miejsce wskazuje wspólną kartę „W budowie” (`wBudowie`), a MD-ZESPOL
 * wpisuje tu `komponent: () => import("components/Polityki/dzial/ProceduryDzialu")`.
 *
 * [MD-ZESPOL 7.10.2026] Dostępy, Sprzęt, Sejf haseł i Dokumenty wskazują PRAWDZIWE miejsca paczki (`pages/mojDzial/miejsca/*`).
 * Procedury ZOSTAJĄ na `wBudowie`: komponent trybu działu z aneksu PROC-MD jeszcze nie istnieje (dzisiejszy `ProceduryDzialu` to
 * stara strona z własnym nagłówkiem, paskiem czterech etapów i szufladą nad szufladą — wpięty w ramę dałby drugi pasek, Z-01).
 * Wpięcie = jedna linia `komponent` po dostarczeniu PROC (zapadka `rejestry.test.js` pilnuje dziś `wBudowie`); numery PR01–PR22
 * stoją w parytecie MD-ZESPOL z polem `czekaNa` (bez udawanego dojścia).
 * [poprawka po przeglądzie MD-ZESPOL] Do tego czasu w NOWYM module drogi do procedur NIE MA: biała karta Dokumentów „Przejdź do
 * Procedur →” (DK06) prowadzi do tego miejsca, czyli do karty „W budowie” — PR01–PR22 i DK06 kończą się na niej aż do komponentu
 * PROC trybu działu z aneksem PROC-MD; MD-WLACZ nie rusza bez niego. Prawdziwe procedury działu są dziś pod starym
 * `/moj-dzial/procedury` (produkcja, poza modułem w budowie).
 */
import { wBudowie } from "../ksztalt";
import { OKNO_SCHOWKA_S, OKNO_UJAWNIENIA_S } from "../../../constants/sejf";
import { GRUPY_MOJEGO_DZIALU, kreatoryMiejsca, miejsceZZakladki, obiektyMiejsca } from "./wspolne";
import { miejsceLudzie } from "./ludzie";

export const miejsceDostepy = miejsceZZakladki("uprawnienia", {
    grupa: GRUPY_MOJEGO_DZIALU.zespol,
    etykieta: "Dostępy",
    zdanie: "Dyski i zasoby działu: kto ma dostęp, komu go nadajesz i kto o niego prosi.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "moge-nadac", etykieta: "Mogę nadać" },
        { id: "z-prosbami", etykieta: "Z prośbami", licznik: true },
        { id: "wszystkie", etykieta: "Wszystkie działu" },
    ],
    obiekty: obiektyMiejsca("zasob", "prosba"),
    pasek: { szukajka: "Szukaj zasobu…" },
    glowa: { zdanieStanu: "8 zasobów w 2 działach · 1 prośba" },
    sekcje: [{ id: "osoby", etykieta: "Dostępy osób zespołu" }],
    zdarzeniaNaZywo: ["drive-access-changed"],
    slowa: ["uprawnienia", "dyski", "zasoby działu", "prośby o dostęp", "akceptanci", "co zespół ma"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Dostepy"),
});

export const miejsceSprzet = miejsceZZakladki("wyposazenie", {
    grupa: GRUPY_MOJEGO_DZIALU.zespol,
    etykieta: "Sprzęt",
    zdanie: "Jaki sprzęt mają Twoi ludzie i w których pomieszczeniach pracują.",
    wzor: "S2",
    widoki: [
        { id: "wszyscy", etykieta: "Wszyscy" },
        { id: "bez-pomieszczenia", etykieta: "Bez pomieszczenia", licznik: true },
    ],
    filtry: ["jednostka", "typ", "tylko"],
    obiekty: obiektyMiejsca("protokol"),
    kreatory: kreatoryMiejsca("potwierdz-pomieszczenia", "zmien-pomieszczenie"),
    pasek: { szukajka: "Szukaj osoby lub sprzętu…", wiecej: ["Potwierdź pomieszczenia za kwartał…", "Pobierz CSV…", "Zgłoś potrzebę sprzętu →"] },
    glowa: { zdanieStanu: "23 osoby · 41 urządzeń · bez sprzętu: 2 · pomieszczenia: czeka" },
    sekcje: [{ id: "dzialowy", etykieta: "Sprzęt przypisany na dział" }],
    slowa: ["wyposażenie IT", "sprzęt", "pomieszczenia", "protokoły sprzętu", "laptop", "urządzenia"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Sprzet"),
});

export const miejsceSejf = miejsceZZakladki("sejf", {
    grupa: GRUPY_MOJEGO_DZIALU.zespol,
    etykieta: "Sejf haseł",
    // [poprawka po przeglądzie MD-ZESPOL 7.10] Liczby okien Z TYCH SAMYCH STAŁYCH co stopka listy, szuflada wpisu i mechanika
    // ujawniania (`constants/sejf`: OKNO_UJAWNIENIA_S = 15 — decyzja właściciela 2026-09-11, `RegulySejfu.OknoUjawnieniaSekundy`;
    // OKNO_SCHOWKA_S = 30). Dawniej zdanie było przepisane z tabeli 2.2 projektu („widać je 5 sekund”), a stopka na tym samym
    // ekranie mówiła „15 s” — fałszywa informacja o zabezpieczeniu. Zapadka N-7 (`tekstyISlowa.rejestr.test.js`) zamraża zdanie
    // z „15 sekund”; tabela 2.2 i 3.11 projektu do poprawienia przez koordynatora (rozliczenie MD-ZESPOL, mdKit2).
    zdanie: `Hasła działu: widać je ${OKNO_UJAWNIENIA_S} sekund, kopia żyje ${OKNO_SCHOWKA_S} sekund, każde użycie jest w dzienniku.`,
    wzor: "S2",
    obiekty: obiektyMiejsca("wpis"),
    kreatory: kreatoryMiejsca("dodaj-haslo"),
    pasek: { szukajka: "Szukaj hasła…", akcjaGlowna: "Dodaj hasło…" },
    glowa: { zdanieStanu: "Wpisów: 31 z 31" },
    slowa: ["hasła", "sejf", "bank haseł", "loginy", "kopiuj hasło", "hasła działu"],
    komponent: () => import("../../../pages/mojDzial/miejsca/SejfDzialu"),
});

export const miejsceDokumenty = miejsceZZakladki("dokumenty", {
    grupa: GRUPY_MOJEGO_DZIALU.zespol,
    etykieta: "Dokumenty",
    zdanie: "Pisma wydawane z działu: rejestr, akceptacje, wysyłka i podpisy.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "wszystkie", etykieta: "Wszystkie" },
        { id: "czekaja-na-decyzje", etykieta: "Czekają na decyzję", licznik: true },
    ],
    obiekty: obiektyMiejsca("wydanie"),
    kreatory: kreatoryMiejsca("wydaj-dokument"),
    pasek: { szukajka: "Szukaj dokumentu…", akcjaGlowna: "Wydaj dokument…", wiecej: ["Zobacz wzory…", "Sortuj według…"] },
    glowa: { zdanieStanu: "12 w tym roku · 2 unieważnione" },
    zdarzeniaNaZywo: ["document-issue-upserted"],
    slowa: ["dokumenty działu", "pisma", "wzory pism", "rejestr wydań", "podpis online", "akceptacja dokumentu"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Dokumenty"),
});

export const miejsceProcedury = miejsceZZakladki("procedury", {
    grupa: GRUPY_MOJEGO_DZIALU.zespol,
    etykieta: "Procedury",
    zdanie: "Procedury Twojego działu: kto ma potwierdzić, co czeka na Ciebie, co przypisać.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "czekaja-na-mnie", etykieta: "Czekają na mnie", licznik: true },
        { id: "wszystkie", etykieta: "Wszystkie" },
    ],
    // Filtr etapu listy nazywa się `filtrEtap` (jak w rejestrze Procedur) — `&etap=` należy do adresu karty procedury.
    filtry: ["filtrEtap", "kategoria", "lista"],
    obiekty: obiektyMiejsca("doc"),
    kreatory: kreatoryMiejsca("przypisz-ludziom"),
    pasek: { szukajka: "Szukaj procedury…", wiecej: ["Nowa procedura działu…"] },
    glowa: { zdanieStanu: "12 osób w zakresie · 9 zaległych potwierdzeń" },
    zdarzeniaNaZywo: ["polityka-upserted", "polityka-obowiazek-upserted"],
    slowa: ["procedury i instrukcje", "polityki działu", "potwierdzenia", "lista kontrolna", "przypisz ludziom"],
    komponent: wBudowie,
});

export const miejscaZespolu = [miejsceLudzie, miejsceDostepy, miejsceSprzet, miejsceSejf, miejsceDokumenty, miejsceProcedury];

export default miejscaZespolu;
